module.exports = __webpack_public_path__ + "img/mk.370004e1.svg";